/* unplugin-vue-components disabled */var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-img",
        {
          staticClass: "px-4",
          attrs: {
            height: _vm.height,
            src: "src/images/parallax/local.webp",
            gradient: "to top right, rgba(0,0,0,.45), rgba(0,0,0,.2)",
            flat: "",
            dark: "",
            tile: "",
          },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 fill-height text-center boas",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c("h1", [_vm._v("Nossa Localização")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.site.end +
                        " - " +
                        _vm.site.city +
                        "-" +
                        _vm.site.state
                    )
                  ),
                  _c("br"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-container", [
        _c(
          "div",
          { staticClass: "my-3 mx-lg-12 mx-4" },
          [_c("street-view-panorama", { attrs: { site: _vm.site } })],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }